import { OrganizationCarrier } from '../../types';
import { OrgQueryKeys } from '../config';
import { useOrganizationQuery } from './use-organization-query';

export const useCarriers = () => {
    const { data: carriers, isLoading: isLoadingCarriers, organizationId: organizationId } = useOrganizationQuery<OrganizationCarrier[]>(OrgQueryKeys.carriers);

    return { carriers, isLoadingCarriers, organizationId };
};
